import { Box, Divider } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Page } from '@flecto/ui/saas'
import { PageHeader } from '@flecto/ui/saas/components/Page/Header'

import { FiltersScheduler } from '../components/FiltersScheduler/FiltersScheduler'
import { SchedulerGrouped } from '../components/SchedulerGrouped/SchedulerGrouped'
import { TogglePageScheduler } from '../components/TogglePageScheduler/TogglePageScheduler'
import styles from './styles.module.css'

export function PageScheduler() {
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })

  return (
    <Box className={styles.pageScheduler}>
      <Box className={styles.pageSchedulerHeader}>
        <PageHeader>
          <Page.Title>{t('schedule')}</Page.Title>
          <Page.Actions>
            <FiltersScheduler />
            <Divider orientation='vertical' size='xs' mx='md' h={30} mt='sm' />
            <TogglePageScheduler />
          </Page.Actions>
        </PageHeader>
      </Box>
      <Box className={styles.pageSchedulerContent}>
        <SchedulerGrouped />
      </Box>
    </Box>
  )
}
